import React from 'react';
import styled from 'styled-components';
import HeaderlessConversationView from './HeaderlessConversationView';

const TabWrapper = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #f9fbff 0%, #f5f8fd 100%);
  position: relative;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    height: 100%;
    min-height: 0;
  }
`;

const ConversationTab = ({ conversation, expertId, setConversation }) => {
  return (
    <TabWrapper>
      <HeaderlessConversationView 
        conversation={conversation}
        expertId={expertId}
        setConversation={setConversation}
      />
    </TabWrapper>
  );
};

export default ConversationTab; 